export function appRedirect({ app, redirect }, payload) {
  if (process.server) {
    return redirect(payload)
  }

  return new Promise((resolve, reject) => {
    app.router.push(payload, resolve, reject)
  }).catch(() => {})
}
